import { render, staticRenderFns } from "./VisitaData.vue?vue&type=template&id=753bf18b&"
import script from "./VisitaData.vue?vue&type=script&lang=js&"
export * from "./VisitaData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports